import React, { FC, useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { useDispatch, useSelector } from 'react-redux'
import { IBankAccount } from '@sparling/financial-common'
import { Typography } from '@mui/material'
import { TableComponent } from '../../../../../../../components/Dashboard/Table'
import { columns } from './BankAccountsList'
import { BankAccountsModal } from './BankAccountsModal'
import { userSfBankAccountsSelector } from '../../../../../../../store/selectors'
import { readUserSfBankAccountsRequest } from '../../../../../../../store/actions'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    marginTop: theme.spacing(3),
    padding: theme.spacing(3),
    height: '100%',
  },
  titleWrap: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minWidth: 400,
  },
  table: {
    paddingTop: theme.spacing(2),
  },
  buttonWrap: {
    justifyContent: 'flex-end',
  },
}))

export const BankAccounts: FC = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { data, status } = useSelector(userSfBankAccountsSelector)
  const [isOpenAccountModal, setOpenAccountModal] = useState<boolean>(false)
  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null)

  const loadAccountsData = useCallback(
    (page = 1) => {
      dispatch(
        readUserSfBankAccountsRequest({
          page: Math.max(1, page),
        }),
      )
    },
    [dispatch],
  )

  useEffect(() => {
    loadAccountsData()
  }, [loadAccountsData])

  const getSelectedElementIdHandle = useCallback((id) => {
    setSelectedAccountId(id)
  }, [])

  const openBankAccountModalHandle = useCallback(() => {
    setOpenAccountModal(true)
    setSelectedAccountId(null)
  }, [])

  const closeBankAccountModalHandle = useCallback(() => setOpenAccountModal(false), [])

  return (
    <Grid container display={'flex'}>
      <Grid container className={classes.container}>
        <Grid container className={classes.titleWrap}>
          <Grid item xs={12} display="flex">
            <Typography variant={'h6'}>Bank Accounts</Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.table}>
          <TableComponent
            page={data.meta.currentPage}
            getUserId={getSelectedElementIdHandle}
            columns={columns}
            data={data.items}
            params={data.meta}
            onShow={openBankAccountModalHandle}
            loading={status === 'LOADING'}
            loadData={loadAccountsData}
          ></TableComponent>
        </Grid>
      </Grid>
      {isOpenAccountModal && (
        <BankAccountsModal
          isOpen={true}
          modalClose={closeBankAccountModalHandle}
          fields={data.items.find((item) => item.id === selectedAccountId) as IBankAccount}
        />
      )}
    </Grid>
  )
}
